import { Field, ErrorMessage, FieldProps } from 'formik';
import { DatePicker as AntDatePicker, Flex } from 'antd';
import dayjs from 'dayjs';
import TextError from 'components/TextError';
import FieldLabel from 'components/FieldLabel';
import If from 'components/If';
import LazySvg from 'components/LazySvg';
import { DatePickerProps } from 'utils/globalTypes';

function DatePicker(props: DatePickerProps) {
  const { label, name, qaSelector, showErrMsg = true, info, ...rest } = props;
  return (
    <Flex vertical align='flex-start' className='formFieldContainer'>
      <FieldLabel label={label} info={info} />
      <Field name={name}>
        {({ field, meta, form }: FieldProps) => {
          const { setFieldValue, setFieldTouched } = form;
          const { value } = field;
          const fieldStatus = meta.touched && meta.error ? 'error' : '';
          const onBlur: DatePickerProps['onBlur'] = (event, blurInfo) => {
            setFieldTouched(name, true);
            rest.onBlur?.(event, blurInfo);
          };

          const onChange: DatePickerProps['onChange'] = (date, dateString) => {
            setFieldTouched(name, true);
            setFieldValue(name, date ? date.format('YYYY-MM-DD') : '');
            rest.onChange?.(date, dateString);
          };
          return (
            <AntDatePicker
              className='fullWidth'
              suffixIcon={<LazySvg name='calendar' />}
              id={name}
              name={name}
              {...rest}
              status={fieldStatus}
              value={value ? dayjs(value) : null}
              onChange={onChange}
              onBlur={onBlur}
              data-qa-selector={qaSelector}
            />
          );
        }}
      </Field>
      <If condition={showErrMsg}>
        <ErrorMessage name={name}>
          {(msg) => (
            <TextError
              msg={msg}
              qaSelector={qaSelector ? `${qaSelector}-error` : undefined}
            />
          )}
        </ErrorMessage>
      </If>
    </Flex>
  );
}

export default DatePicker;
